import React from "react";
import { Modal } from "react-bootstrap";

const ViewDescriptionModal = ({ show, onHide, title, htmlContent }) => {
  return (
    <Modal show={show} onHide={onHide} size="lg" centered scrollable>
      <Modal.Header closeButton>
        <Modal.Title>{title || "Full Description"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {htmlContent ? (
          <div
            className="cms-content-description-preview"
            dangerouslySetInnerHTML={{ __html: htmlContent }}
          />
        ) : (
          <p className="text-muted mb-0">No description available.</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={onHide}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ViewDescriptionModal;
